var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79308 15.207C7.60561 15.0194 7.50029 14.7651 7.50029 14.5C7.50029 14.2348 7.60561 13.9805 7.79308 13.793L11.0861 10.5L7.79308 7.20697C7.69757 7.11472 7.62139 7.00438 7.56898 6.88237C7.51657 6.76037 7.48898 6.62915 7.48783 6.49637C7.48668 6.36359 7.51198 6.23191 7.56226 6.10902C7.61254 5.98612 7.68679 5.87447 7.78069 5.78057C7.87458 5.68668 7.98623 5.61243 8.10913 5.56215C8.23202 5.51187 8.3637 5.48656 8.49648 5.48772C8.62926 5.48887 8.76048 5.51646 8.88249 5.56887C9.00449 5.62128 9.11483 5.69746 9.20708 5.79297L13.2071 9.79297C13.3946 9.9805 13.4999 10.2348 13.4999 10.5C13.4999 10.7651 13.3946 11.0194 13.2071 11.207L9.20708 15.207C9.01955 15.3944 8.76525 15.4998 8.50008 15.4998C8.23492 15.4998 7.98061 15.3944 7.79308 15.207Z",
    fill: "#1F2A37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.a1c49803f4e03a6e30ae45870d019a90.svg";
export { ForwardRef as ReactComponent };